"use strict";
exports.__esModule = true;
var ramda_1 = require("ramda");
exports["default"] = ramda_1.pick([
    'download',
    'href',
    'hrefLang',
    'media',
    'ping',
    'rel',
    'target',
    'type',
]);
//# sourceMappingURL=a.js.map